import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveWeekTimeRecordsRequestPending(scope, startDate, endDate) {
      const req = getState().find((req) =>
        matchRequest(req, scope, startDate, endDate),
      );

      return req ? req.request.isPending : false;
    },
    isRetrieveWeekTimeRecordsRequestSuccess(scope, startDate, endDate) {
      const req = getState().find((req) =>
        matchRequest(req, scope, startDate, endDate),
      );

      return req ? req.request.isSuccessful : false;
    },
    isRetrieveWeekTimeRecordsRequestFailure(scope, startDate, endDate) {
      const req = getState().find((req) =>
        matchRequest(req, scope, startDate, endDate),
      );

      return req ? req.request.isFailure : false;
    },
    areWeekTimeRecordsDirty(scope, startDate, endDate) {
      const req = getState().find((req) =>
        matchRequest(req, scope, startDate, endDate),
      );

      return req ? req.isDirty : false;
    },
    getWeekTimeRecords(scope, startDate, endDate) {
      const req = getState().find((req) =>
        matchRequest(req, scope, startDate, endDate),
      );

      return req ? req.timeRecords : [];
    },
  };
}

export { createSelector };
